import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        fileGeneratingProgress: 0,
        showOutput: true,
        notes: [],
        noteData: {},
        lastOpenNote: null
    },
    mutations: {
        GET_NOTE(state, payload) {
            state.noteData = payload;
        },
        ADD_NOTE(state, payload) {
            state.notes.push(payload);
        },
        DELETE_NOTE(state, payload) {

            function deleteNoteOrFolder(items) {
                _.forEach(items, function (item) {

                    // QUESTION - seems expensive as we have a loop in a loop
                    _.remove(items, function(item) {
                        if (item.id === payload.id) {
                            // console.log(item);
                            return true;
                        }
                        // NOTE: use above for demo purposes
                        // return item.id === comment.id
                    });

                    _.has(item, 'notes') ? deleteNoteOrFolder(item.notes, item) : 0;
                });
            }

            var notes = state.notes;
            
            deleteNoteOrFolder(notes);

            _.each(notes, (note, i) => {
                Vue.set(state.notes, i, note);
            });
            
            state.noteData = {};
        },
        UPDATE_NOTE(state, payload) {
            var index = _.findIndex(state.notes, function(n) { return n.id == payload.id; });
            if (index) {
                state.notes[index] = payload;
            }
        },
        UPDATE_NOTE_LIST (state, payload) {
            state.notes = payload;
        },
        TOGGLE_SHOW_OUTPUT(state) {
            state.showOutput = !state.showOutput;
        },
        UPDATE_FILE_GENERATING_PROGRESS(state, payload) {
            state.fileGeneratingProgress = payload;
        },
        UPDATE_LAST_OPEN_NOTE(state, payload) {
            state.lastOpenNote = payload;
        },
        INITIALISE_STORE(state) {
			// Check if the ID exists
			if(localStorage.getItem('store')) {
				this.replaceState(
					Object.assign(state, JSON.parse(localStorage.getItem('store')))
                );
                state.noteData = {};
			}
		}
    },
    actions: {
        showNote: (context, param) => {
            // let data = context.getters.singleNote(param);
            context.commit('GET_NOTE', param);
            context.commit('UPDATE_LAST_OPEN_NOTE', param.id);
        },
        addNote: (state, payload) => {
            state.commit('ADD_NOTE', payload);
        },
        removeNote: (state, payload) => {
            state.commit('DELETE_NOTE', payload);
        },
        updateNote: (state, payload) => {
            state.commit('UPDATE_NOTE', payload);
        },
        updateFileGeneratingProgress: (state, payload) => {
            state.commit('UPDATE_FILE_GENERATING_PROGRESS', payload);
        },
        updateNoteList: (state, payload) => {
            state.commit('UPDATE_NOTE_LIST', payload);
        }
    },
    modules: {
    },
    getters: {
        notes: state => {
            return state.notes;
        },
        singleNote: note => {
            return note;
        },
        getCurrentFileGeneratingProgress: state => {
            return state.fileGeneratingProgress;
        }
    },
});